import React from "react"
import PropTypes from "prop-types"

import {Hr} from "@irati/ui/src/Layout"
import {injectIntl} from "@irati/utils/lang"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"
import {H4} from "@irati/ui/src/Typography"

import ReadMore from "../ReadMore/ReadMore"

const DealDescription = ({deal, formatMessage}) => {
  if (!deal.description) return null
  const header = formatMessage({id: deal.type === DEAL_TYPE_COMPANY_BENEFITS ?
    "perks.components.dealInfoBlock.dealDescription.benefitDesc" : "perks.components.dealInfoBlock.dealDescription.perkDesc"})
  return (
    <section>
      <Hr large />
      <H4 marginBottom={2}>{header}</H4>
      <ReadMore maxHeightPx={48}>
        {deal.description}
      </ReadMore>
    </section>
  )
}

DealDescription.propTypes = {
  deal: PropTypes.shape({
    type: PropTypes.string.isRequired,
    description: PropTypes.string
  }).isRequired,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(DealDescription)
